import { render, staticRenderFns } from "./SetupTukarGift.vue?vue&type=template&id=1bbc04ba"
import script from "./SetupTukarGift.vue?vue&type=script&lang=js"
export * from "./SetupTukarGift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports